var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-color-picker',{model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})
}
var staticRenderFns = []

export { render, staticRenderFns }